import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import Careers from '../views/Careers'
import About from '../views/About'
import Privacy from '../views/Privacy'
import Security from '../views/Security'
import Holiday2019 from '../views/Holiday2019'
import Alcohol from '../views/Alcohol'
import PrivacyApp from '../views/PrivacyApp'
import OpenPositions from '../views/OpenPositions'
import AttachVertical from '../views/AttachVertical'
import RetailPartners from '../views/RetailPartners'
import RedirectView from '../views/RedirectView'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'RedirectView',
      component: RedirectView
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js